module.exports = __webpack_public_path__ + "img/chris-headshot.3c3f23dc.jpg";